import React, { Component } from 'react';

import TeacherCard from './../TeacherCard';

class TeachersGrid extends Component {
  state = {
    teachersToShow: [],
    loading: true
  };

  componentWillMount = () => {
    fetch('https://raw.githubusercontent.com/VahanSargsyan/dumy/master/dumyData.json', { method: 'GET'})
      .then(resp => resp.json())
      .then(resp => this.setState({
              loading: false,
              teachersToShow: resp
            })
  )};

  filter = (arr, num, sub) => {
      return arr.reduce(function (a, b) {
        if (b.subjects.includes(sub) && b.classes.includes(num)) {
          a.push(b)
        }
        return a;
      }, [])
  };
  render() {
    let grid;
    if (this.state.loading) {
      grid = <p>Բեռնում․․․․․</p>
    } else {
      grid = this.filter(
        this.state.teachersToShow,
        this.props.classNumber,
        this.props.subject
      ).map(v => (
        <TeacherCard key={v.name} setTeacher={this.props.setTeacher} teacher={v} isActive={true}/>
      ));
    }

    return (
      <div className="teachersGrid">
        {(grid.length) ? grid : <p className="message text-center">
          Ձեր հարցմամբ ուսուցիչ չի գտնվել
        </p> }
      </div>
    )
  }
}

export default TeachersGrid;